import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import classNames from 'classnames';

import { toJS } from 'src/utils/ChangeSpy';

import style from './style.module.css';

const ExecutiveDeals = ({ data }) => {
  const deals = toJS(data.getIn(['executiveDeals', 'countExecutiveDeals']));
  const { isFetching } = toJS(data.get('executiveDeals'));

  return (
    <div className={classNames(style.host, 'bg-white d-flex p20')}>
      {isFetching === false && (
        <>
          <div className={classNames(style.icon, 'h5')}>
            <i className="fa fa-briefcase" />
          </div>
          <div>
            <p className="h3 text-bold m0 p5">{deals}</p>
            <p className="h5 m0 p5">Executive Placed/Initiated Deals For</p>
          </div>
        </>
      )}
    </div>
  );
};

ExecutiveDeals.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
};

export default ExecutiveDeals;
